"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isString = void 0;
exports.isString = (value) => typeof value === "string";
//# sourceMappingURL=is-string.js.map